import angular from 'angular';
import moment from 'moment';
import { FolhasdePontoService } from '../folhasdeponto.service';
import { ApuracoesPontoService } from '../../ApuracoesPonto/apuracoesponto.service';
import { FolhasPontoVisualizarpdfModalService } from '../modals/visualizarpdf/visualizarpdf.modal.service';
import { FolhasPontoFalhaGeracaoModalService } from '../modals/falhageracao/falhageracao.modal.service';
import { FolhasPontoCancelarAssinaturaModalService } from '../modals/cancelarassinatura/cancelarassinatura.modal.service';
import { ModalConfirmService } from '../../../../../shared/components/modal-confirm/modal.confirm.service';
import { IFolhaPonto, IFolhaPontoHistorico, IFolhaPontoHistoricoAPI } from '../../models/folhaponto.model';
import { IApuracaoFilter, IApuracaoPonto, IApuracaoSelectItem } from '../../models/apuracaoponto.model';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../../../utils/nsj-table';

type IFolhasPontoFilters = {
	apuracao: IApuracaoFilter | null;
	situacao: string;
	lotacao: { lotacao: string } | null;
	departamento: { departamento: string } | null;
	grupo: { grupo: string } | null;
	trabalhador: { trabalhador: string } | null;
	situacaoColaborador: string | null;
};

type HistoricoFiltro = 'all' | 'falhas' | 'manuais' | 'sistema';

export class FolhasPontoIndexController {

    static $inject = [
		'$rootScope',
		'$scope',
		'$state',
		'$stateParams',
		'FolhasdePontoService',
		'ApuracoesPontoService',
		'FolhasPontoVisualizarpdfModalService',
        'FolhasPontoFalhaGeracaoModalService',
		'FolhasPontoCancelarAssinaturaModalService',
		'ModalConfirmService',
		'NewToaster'
	];

    // initial state
    public entities: Array<IFolhaPonto> = [];
    public apuracoes: Array<IApuracaoPonto> = [];
    public busy: boolean = false;
	public apuracoesSelect: IApuracaoSelectItem[] = [];
	public filters: IFolhasPontoFilters = {
		apuracao: null,
		situacao: '',
		lotacao: null,
		departamento: null,
		grupo: null,
		trabalhador: null,
		situacaoColaborador: '00',
	};
    public filtersParams = {
        empresa: '',
        estabelecimento: ''
    };
	public nomeArquivoDownload: string = '';
	public prefixoArquivo: string = 'folhasponto-';
	public botaoInformativo: any = null;
	public labelSituacao: boolean = false;
	public labelSituacaoAssinatura: boolean = false;
	public assinaturaDigitalHabilitada: boolean = false;
	public selectSituacao: string[] | number[];
	public solicitarAssinaturasBtn: boolean = false;
	public folhaSelecionada: IFolhaPonto | null = null;
	public historicoFolha: IFolhaPontoHistorico[] = [];
	public historicoAberto: boolean = false;
	public historicoCarregando: boolean = false;
	public historicoErro: boolean = false;
	public historicoFiltro: HistoricoFiltro = 'all';
	public historicoFiltros = [
		{ label: 'Exibir todos', value: 'all' as const },
		{ label: 'Apenas falhas', value: 'falhas' as const },
		{ label: 'Apenas ações manuais', value: 'manuais' as const },
		{ label: 'Apenas ações do sistema', value: 'sistema' as const }
	];

    // table
	public checkboxPreenchidos: Array<IFolhaPonto> = [];
	public carregouTudo: boolean = false;
	public carregouPart: boolean = false;
	public checkToggle: any = {};
	public fields: any[] = [];

    constructor (
        public $rootScope: angular.IRootScopeService & {
			temPermissao: (arg: string) => boolean,
			liberadoTela: (arg: string) => boolean,
			session: any,
			configuracoes: any,
			nsjGlobals: any
		},
		public $scope: angular.IScope,
		public $state: angular.ui.IStateService,
		public $stateParams: angular.ui.IStateParamsService,
		public FolhasdePontoService: FolhasdePontoService, // = entityService
		public ApuracoesPontoService: ApuracoesPontoService,
		public FolhasPontoVisualizarpdfModalService: FolhasPontoVisualizarpdfModalService,
        public FolhasPontoFalhaGeracaoModalService: FolhasPontoFalhaGeracaoModalService,
		public FolhasPontoCancelarAssinaturaModalService: FolhasPontoCancelarAssinaturaModalService,
		public ModalConfirmService: ModalConfirmService,
		public NewToaster: { pop: Function },
	) {
		if (
			!this.$rootScope.temPermissao('visualizar_folhas_ponto') ||
			!this.$rootScope.liberadoTela('LIBERAR_FOLHAS_PONTO')
		) {
            $state.go('dp');
        }

        /* FOLHA_PONTO_ASSINATURA_HABILITADA vem do tipo de arquivo FOLHA_PONTO quando o
           GED da folha de ponto está liberado, e da configuração antiga quando não está. */
        this.assinaturaDigitalHabilitada =
            this.$rootScope.configuracoes.FOLHA_PONTO_ASSINATURA_HABILITADA &&
		    this.$rootScope.liberadoTela('LIBERAR_PONTO_ASSINATURA');
	    this.selectSituacao = this.setSelectSituacaoOptions(this.assinaturaDigitalHabilitada);
        this.fields = applyNsjTableInlineMobileLabels(this.setTableFields(this.assinaturaDigitalHabilitada));

        this.busy = true;
		this.carregaApuracoes();

		this.botaoInformativo = 'Solicitar assinaturas de todos os colaboradores que contém a situação "Enviar para assinatura" na folha de ponto.';

        $scope.$on('ponto_apuracoesfolhas_index_loaded', (event, args: any) => {
			if (this.entities.length === 0) {
				this.entities = args;
			}
            this.setCheckboxDisabled();
			this.checar_todos();
			this.busy = false;
        });

        $scope.$on('ponto_apuracoesfolhas_index_list_finished', () => {
			this.carregouTudo = true;
			this.busy = false;
			this.solicitarAssinaturasBtn = this.desativaSolicitarAssinaturasBtn();
        });

        $scope.$on('apuracoesponto_index_loaded', () => {
			if (this.ApuracoesPontoService.loadParams.finished ||
                this.ApuracoesPontoService.loadParams.to_load === 0
            ) {
                this.montaApuracaoSelect();
            }
        });

        $scope.$on('ponto_apuracoesfolhas_downloadfolhaslote_sucesso', (event, args: any) => {
            this.busy = false;
			this.trataDownload(args.data);
            this.NewToaster.pop({
                type: 'success',
                title: 'Download realizado com sucesso!',
            });
        });

        $rootScope.$on('ponto_apuracoesfolhas_downloadfolhaslote_erro', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro no download.',
            });
        });

        $scope.$on('ponto_apuracoesfolhas_downloadfolhasunificado_sucesso', (event, args: any) => {
            this.busy = false;
			this.trataDownload(args.data, true);
            this.NewToaster.pop({
                type: 'success',
                title: 'Download realizado com sucesso!',
            });
        });

        $scope.$on('ponto_apuracoesfolhas_downloadfolhasunificado_erro', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro no download.',
            });
        });

        $scope.$on('ponto_apuracoesfolhas_regerar_folha_iniciado', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                title: 'A folha de ponto foi gerada com sucesso!',
            });
        });

        $scope.$on('ponto_apuracoesfolhas_regerar_folha_erro', (_, args: any) => {
            this.busy = false;
            const message = args && args.data && typeof args.data === 'string' ? args.data : null;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao gerar a folha de ponto.',
                body: message
            });
        });

        $scope.$on('ponto_apuracoesfolhas_get_pdf_iniciado', (event, args: any, salvar: boolean) => {
            if (salvar) {
				this.busy = false;
				this.trataDownload(args.data, salvar);
				this.NewToaster.pop({
					type: 'success',
					title: 'Download realizado com sucesso!',
				});
			}
        });

		$scope.$on('ponto_apuracoesfolhas_solicitar_assinatura_sucesso', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                title: 'Solicitação de assinatura enviada com sucesso!',
            });
			this.filterReload();
        });

		$rootScope.$on('ponto_apuracoesfolhas_solicitar_assinatura_erro', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao enviar a solicitação de assinatura.',
            });
        });

		$scope.$on('ponto_apuracoesfolhas_cancelar_assinatura_sucesso', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'success',
                title: 'Folha cancelada com sucesso!',
            });
			this.filterReload();
        });

		$rootScope.$on('ponto_apuracoesfolhas_cancelar_assinatura_erro', (_, args: any) => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao cancelar a folha.',
                body: this.extrairMensagemErro(args)
            });
        });
    }

	carregaApuracoes() {
		this.busy = true;
		this.ApuracoesPontoService.constructors['vigente'] = false;
		this.ApuracoesPontoService.constructors['empresa'] = this.$rootScope.session.entities.empresa.empresa;
		this.ApuracoesPontoService.constructors['estabelecimento'] = '';
		this.apuracoes = this.ApuracoesPontoService.reload();
	}

    setCheckboxDisabled() {
        this.entities.forEach((entity) => {
            if (entity.status === 0 || entity.status === 1) {
                entity['disableCheckbox'] = true;
            }
        });
    }

    setSelectSituacaoOptions(isAssinaturaDigitalHabilitada: boolean = false) {
        return isAssinaturaDigitalHabilitada ?
            [
                'status_0',
                'status_1',
                'status_4',
                'status_2',
                'situacaoassinatura_1',
                'situacaoassinatura_2',
                'situacaoassinatura_3',
                'situacaoassinatura_4'
            ] : [0, 1, 2, 3, 4];
    }

    setTableFields(isAssinaturaDigitalHabilitada: boolean = false) {
        const assinaturaFields = isAssinaturaDigitalHabilitada ? [
            {
                value: 'datasolicitacaoassinatura',
                label: 'Enviado em',
                type: 'date',
                style: 'title',
                copy: '',
            }
        ] : [];

        return [
            {
                value: 'trabalhador.codigo',
                label: 'Matrícula',
                type: 'string',
                style: 'title',
                copy: '',
                customHeaderStyle: 'max-width-matricula'
            }, {
                value: 'trabalhador.nome',
                label: 'Colaborador',
                type: 'string',
                style: 'title',
                copy: '',
            }, {
                value: 'status',
                label: 'Situação',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnScope: {
                    abrirFalhaGeracaoModal: (entity: IFolhaPonto) => {
                        if (!entity.logerro) {
                            return;
                        }
                        this.FolhasPontoFalhaGeracaoModalService.open(entity.logerro);
                    },
                    getSituacaoFolha: (entity: IFolhaPonto) => this.getSituacaoFolha(entity),
                    exibeSituacaoAssinatura: (entity: IFolhaPonto) => this.exibeSituacaoAssinatura(entity),
                },
                customCollumnHtml: () => {
                    let someHtmlVar = `
                        <span ng-if="!customCollumnScope.exibeSituacaoAssinatura(tableRowEntity)"
                        >
                            <label
                                class="label {{tableRowEntity.status | situacaoFolhasdepontoClassesEnum}}"
                                ng-class="{'cursor-pointer': tableRowEntity.status === 4 }"
                                ng-click="tableRowEntity.status === 4 &&
                                    customCollumnScope.abrirFalhaGeracaoModal(tableRowEntity)"
                            >
                                {{customCollumnScope.getSituacaoFolha(tableRowEntity)}}
                            </label>
                        </span>
                        <span ng-if="customCollumnScope.exibeSituacaoAssinatura(tableRowEntity)"
                        >
                            <label
                                class="label {{tableRowEntity.situacaoassinatura | situacaoFolhasdepontoAssinaturaClassesEnum}}"
                            >
                                {{tableRowEntity.situacaoassinatura | situacaoFolhasdepontoAssinaturaEnum}}
                            </label>
                        </span>
                      `;
                  return someHtmlVar;
                },
            },
            ...assinaturaFields,
            {
                value: 'apuracaofolha',
                label: '',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnScope: {
                    downloadIndividual: (entity: IFolhaPonto) => {
                        this.downloadIndividual(entity);
                    },
                    regerarFolha: (entity: IFolhaPonto) => {
                        this.regerarFolha(entity);
                    },
                    abrirModal: (entity: IFolhaPonto) => {
                        this.FolhasPontoVisualizarpdfModalService.open(entity);
                    },
                    verHistorico: (entity: IFolhaPonto) => {
                        this.verHistorico(entity);
                    },
                    solicitacaoDeAssinaturaIndividualOuGrupo: (entity: IFolhaPonto) => {
                        this.solicitacaoDeAssinaturaIndividualOuGrupo(entity);
                    },
                    cancelarAssinatura: (entity: IFolhaPonto) => {
                        this.cancelarAssinatura(entity);
                    },
                    podeGerarFolha: (entity: IFolhaPonto) => {
                        return this.podeGerarFolha(entity);
                    },
                    podeCancelarAssinatura: (entity: IFolhaPonto) => {
                        return this.podeCancelarAssinatura(entity);
                    }
                },
                customLabelHtml: buildNsjTableInlineMobileLabel('', { showOnMobile: false }),
                customCollumnHtml: () => {
                    let someHtmlVar = `
                        <div ng-if="tableRowEntity.status >= 2"
                            class="display-flex justify-content-end"
                        >
                            <nsj-button-dropdown
                                border="none"
                                split="false"
                                size="sm"
                                icon="fas fa-ellipsis-v"
                                dropdown-direction="right"
                                class="menuEllipsis"
                            >
                                <item-dropdown
                                    ng-if="${this.$rootScope.temPermissao('solicitar_assinatura_folha')} &&
                                        ${isAssinaturaDigitalHabilitada} &&
                                        (tableRowEntity.status === 2 || tableRowEntity.status === 3) &&
                                        !tableRowEntity.situacaoassinatura &&
                                        !tableRowEntity.previa"
                                    item-label="Solicitar assinatura"
                                    ng-click="customCollumnScope.solicitacaoDeAssinaturaIndividualOuGrupo(entity)"
                                ></item-dropdown>
                                <item-dropdown
                                    ng-if="(tableRowEntity.status === 2 ||
                                        tableRowEntity.status === 3 ||
                                        tableRowEntity.situacaoassinatura === 4)"
                                    item-label="Visualizar"
                                    ng-click="customCollumnScope.abrirModal(entity)"
                                ></item-dropdown>
                                <item-dropdown
                                    ng-if="(tableRowEntity.status === 2 ||
                                        tableRowEntity.status === 3 ||
                                        tableRowEntity.situacaoassinatura === 4)"
                                    item-label="Download"
                                    ng-click="customCollumnScope.downloadIndividual(entity)"
                                ></item-dropdown>
                                <item-dropdown
                                    ng-if="tableRowEntity.status >= 2"
                                    item-label="Ver histórico"
                                    ng-click="customCollumnScope.verHistorico(tableRowEntity)"
                                ></item-dropdown>
                                <item-dropdown
                                    ng-if="customCollumnScope.podeCancelarAssinatura(tableRowEntity)"
                                    item-label="Cancelar folha"
                                    ng-click="customCollumnScope.cancelarAssinatura(tableRowEntity)"
                                ></item-dropdown>
                                <item-dropdown
                                    ng-if="customCollumnScope.podeGerarFolha(tableRowEntity)"
                                    item-label="{{ tableRowEntity.previa ?
                                        'Gerar prévia da folha novamente': 'Gerar folha novamente'
                                    }}"
                                    ng-click="customCollumnScope.regerarFolha(entity)"
                                ></item-dropdown>
                            </nsj-button-dropdown>
                        </div>
                      `;
                  return someHtmlVar;
                },
            },
        ];
    }

    /* INÍCIO - COMBO DE FUNÇÕES PARA HABILITAR AS FUNÇÕES SELECIONAR TODOS E DOWNLOAD EM LOTE */
	checar_todos(): void {
		this.checkToggle = document.getElementById('check_all') as HTMLInputElement;

		if (this.checkToggle.checked && !this.checkToggle.indeterminate) {
			let checked = this.entities.filter((entity: any): boolean => !entity.disableCheckbox);
			this.checkboxPreenchidos = angular.copy(checked);
		} else {
			this.checkboxPreenchidos = [];
		}
	}

	temTodosMarcados(): boolean {
		return !!this.entities.length && (this.checkboxPreenchidos.length === this.entities.length);
	}

	naoTemTodosMarcados(): boolean {
		return !!this.checkboxPreenchidos.length && !this.temTodosMarcados();
	}
	/* FIM - COMBO DE FUNÇÕES PARA HABILITAR AS FUNÇÕES SELECIONAR TODOS E DOWNLOAD EM LOTE */

	getRowCustomClass(entity: IFolhaPonto & { rowcustomclass: string} ): string {
		return entity.rowcustomclass;
	}

	montaApuracaoSelect(): void {
		this.apuracoesSelect = this.apuracoes.map((element) => {
			const { nome: nomeReferencia, referencia } = this.getReferenciaApuracao(element);
			return {
				periodo: `
                    ${moment(element.inicioapuracao).format('DD/MM/YYYY')} a
                    ${moment(element.terminoapuracao).format('DD/MM/YYYY')} ${nomeReferencia}`,
				inicioapuracao: element.inicioapuracao,
				terminoapuracao: element.terminoapuracao,
				apuracaoponto: element.apuracaoponto,
                status: element.status,
                referencia
			};
		});
        this.setFilterApuracao();
        this.filterApuracao();
	}

    isApuracaoAtual(apuracao: IApuracaoPonto) {
        const dataHoje = moment().startOf('day');
        const inicioApuracao = moment(apuracao.inicioapuracao).startOf('day');
        const terminoApuracao = moment(apuracao.terminoapuracao).endOf('day');

        if (!inicioApuracao.isValid() || !terminoApuracao.isValid()) {
            return false;
        }

        return dataHoje.isBetween(inicioApuracao, terminoApuracao, undefined, '[]');
    }

	getReferenciaApuracao(apuracao: IApuracaoPonto) {
		if (apuracao.trabalhadorobj?.trabalhador) {
            return {
                nome: `- Trabalhador: ${apuracao.trabalhadorobj.nome}`,
                referencia: apuracao.trabalhadorobj
            };
        }
        if (apuracao.lotacaoobj?.lotacao) {
            return {
                nome: `- Lotação: ${apuracao.lotacaoobj.nome} `,
                referencia: apuracao.lotacaoobj
            };
        }
        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return {
                nome: `- Estabelecimento: ${apuracao.estabelecimentoobj.nomefantasia}`,
                referencia: apuracao.estabelecimentoobj
            };
        }
        if (apuracao.empresaobj?.empresa) {
            return {
                nome: `- Empresa: ${apuracao.empresaobj.razaosocial}`,
                referencia: apuracao.empresaobj
            };
        }
        return {
            nome: '',
            referencia: null
        };
    }

    setFilterApuracao() {
        if (!this.apuracoesSelect.length) {
            return;
        }

        const hasApuracaoParam = this.valorExiste(this.$stateParams.apuracaoponto);
        if (hasApuracaoParam) {
            const apuracao = this.apuracoesSelect.find(elem => elem.apuracaoponto === this.$stateParams.apuracaoponto);
            this.filters.apuracao = apuracao ?? {
                apuracaoponto: this.$stateParams.apuracaoponto,
                referencia: null
            };
            return;
        }

        const dataAtual = moment();
        const apuracaoAtual = this.apuracoesSelect.find(apuracao => {
            const inicioApuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD');
            const terminoApuracao = moment(apuracao.terminoapuracao, 'YYYY-MM-DD');
            return dataAtual.isBetween(inicioApuracao, terminoApuracao, undefined, '[]')
                && apuracao.referencia && ('empresa' in apuracao.referencia);
        });

        if (apuracaoAtual) {
            this.filters.apuracao = apuracaoAtual;
            return;
        }
        this.filters.apuracao = this.apuracoesSelect[0];
    }

    filterApuracao() {
        const apuracao = this.filters.apuracao;
        if (!apuracao) {
            this.busy = false;
            return;
        }

        const filtersToReset = ['grupo', 'lotacao', 'departamento', 'trabalhador'];
        filtersToReset.forEach(key => this.filters[key] = null);

        let empresa = this.$rootScope.session.entities.empresa.empresa;
        let estabelecimento = '';

        const referencia = apuracao.referencia;
        if (!referencia) {
            this.refreshFilters(empresa, estabelecimento);
            this.filterReload();
            return;
        }

        if ('empresa' in referencia) {
            empresa = referencia.empresa;
        } else if ('estabelecimento' in referencia) {
            estabelecimento = referencia.estabelecimento;
        }

        this.refreshFilters(empresa, estabelecimento);

        if ('lotacao' in referencia) {
            this.filters.lotacao = referencia;
            this.reloadLotacao();
            return;
        } else if ('trabalhador' in referencia) {
            this.filters.trabalhador = referencia;
        }

        this.filterReload();
    }

    refreshFilters(empresa: string = '', estabelecimento: string = '') {
        this.filtersParams = { empresa, estabelecimento };

        const events = ['trabalhador_refresh', 'lotacao_refresh', 'departamento_refresh'];

        events.forEach(event =>
            this.$rootScope.$broadcast(event, this.filtersParams)
        );
    }

    downloadIndividual(entity: IFolhaPonto) {
        this.busy = true;
		this.nomeArquivoDownload = '';
        const inicioapuracao = moment(entity.apuracaoponto.inicioapuracao, 'YYYY-MM-DD').format('DD-MM-YYYY');
        const terminoapuracao = moment(entity.apuracaoponto.terminoapuracao, 'YYYY-MM-DD').format('DD-MM-YYYY');
        this.nomeArquivoDownload = entity.trabalhador.codigo + ' - ' + entity.trabalhador.nome + ' ' + inicioapuracao + ' ate ' + terminoapuracao;
        this.FolhasdePontoService.visualizarPdf(entity, true);
    }

	downloadLote(pdfUnico: boolean = false) {
		this.busy = true;
		this.nomeArquivoDownload = '';
        let entities: Array<any> = [];
        const inicioapuracao = moment(this.checkboxPreenchidos[0].apuracaoponto.inicioapuracao, 'YYYY-MM-DD').format('DD-MM-YYYY');
        const terminoapuracao = moment(this.checkboxPreenchidos[0].apuracaoponto.terminoapuracao, 'YYYY-MM-DD').format('DD-MM-YYYY');
        this.checkboxPreenchidos.forEach((element: IFolhaPonto) => {
            entities.push({'apuracaofolha' : element['apuracaofolha']});
        });
        this.nomeArquivoDownload = this.prefixoArquivo + inicioapuracao + '-ate-' + terminoapuracao;
        pdfUnico ?
            this.FolhasdePontoService.downloadUnificado(entities) :
            this.FolhasdePontoService.download(entities);
	}

    regerarFolha(entity: IFolhaPonto) {
        const colaboradorNome = entity.trabalhador.nome;
		const liberada = entity.status === 3 ? true : false;
		let textoPersonalizado = liberada ? `A folha de ponto do colaborador(a) ${colaboradorNome} já foi enviada para assinatura. Se você a regerar, precisará reenviá-la ao colaborador(a). Deseja continuar?` : `Você tem certeza que deseja gerar novamente a folha de ponto do colaborador(a) ${colaboradorNome}?`;
        const textos = {
            title: 'Gerar Novamente',
            confirmText: textoPersonalizado,
            closeButton: 'Cancelar',
            confirmButton: 'Sim, gerar novamente',
        };

		this.ModalConfirmService.open(entity, 'Apuração', false, textos).result
			.then(() => {
				this.busy = true;
				this.FolhasdePontoService.regerarFolhaIndividual(entity)
				.then().finally(() => this.FolhasdePontoService.reload());
			})
			.catch(() => {/**/});
    }

    filterReload(): void {
		this.busy = true;

        if (!this.filters.apuracao) {
            this.entities = [];
            this.busy = false;
            return;
		}

        const constructor = {
            apuracaoponto_apuracaoponto: this.filters.apuracao.apuracaoponto,
            empresa: this.$rootScope.session.entities.empresa.empresa,
            estabelecimento: ''
        };

        if (this.filters.lotacao) {
			constructor['trabalhador_lotacao'] = this.filters.lotacao.lotacao;
		}

		if (this.filters.departamento) {
			constructor['trabalhador_departamento'] = this.filters.departamento.departamento;
		}

		if (this.filters.grupo) {
			constructor['grupo'] = this.filters.grupo.grupo;
		}

        if (this.filters.trabalhador) {
			constructor['trabalhador_trabalhador'] = this.filters.trabalhador.trabalhador;
		}

		if (this.filters.situacaoColaborador) {
			constructor['trabalhador_status'] = this.filters.situacaoColaborador;
		}

		if (this.filters.situacao) {
			const situacao = this.montaFiltroSituacao(this.filters.situacao);
			constructor[situacao.nome] = situacao.valor;
		}

		this.FolhasdePontoService.constructors = constructor;
		this.entities = [];
		this.entities = this.FolhasdePontoService.reload();
    }

	montaFiltroSituacao(situacao: string) {
		if (this.assinaturaDigitalHabilitada) {
			const situacaoNomeValor = situacao.split('_');
			return {
				nome: situacaoNomeValor[0],
				valor: situacaoNomeValor[1]
			};
		} else {
			return {
				nome: 'status',
				valor: situacao
			};
		}
	}

	reloadLotacao(): void {
        let empresa = this.$rootScope.session.entities.empresa.empresa;
        let estabelecimento = '';

        if (this.filters.apuracao?.referencia) {
            const referencia = this.filters.apuracao.referencia;
            if ('empresa' in referencia) {
                empresa = referencia.empresa;
            } else if ('estabelecimento' in referencia) {
                estabelecimento = referencia.estabelecimento;
            }
        }

        const lotacao = this.filters.lotacao?.lotacao;
        this.filters.trabalhador = null;
        this.$rootScope.$broadcast('trabalhador_refresh', {
            empresa,
            estabelecimento,
            ...(lotacao ? { lotacao } : {})
        });

        this.filterReload();
    }

	trataDownload(data: any, salvar: boolean = false): void {
		let nomeArquivo = '';
        var blob = new Blob([data]);
        let fileURL = (window.URL || window.webkitURL).createObjectURL(blob);
        var a = document.createElement('a');

		if (salvar) {
			nomeArquivo = nomeArquivo = this.nomeArquivoDownload + '.pdf';
		} else {
			nomeArquivo = nomeArquivo = this.nomeArquivoDownload + '.zip';
		}

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = nomeArquivo;
        a.click();
        window.URL.revokeObjectURL(fileURL);
	}

	loadMore(): void {
		this.FolhasdePontoService.loadMore();
	}

	valorExiste(valor: any): boolean {
		return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }

    getSituacaoFolha(entity: IFolhaPonto): string {
        if (entity.previa && entity.status === 2) {
            return 'Prévia gerada';
        }

        switch (entity.status) {
            case null:
            case 0:
                return 'Aguardando geração';
            case 1:
                return 'Gerando';
            case 2:
                return 'Gerada';
            case 3:
                return 'Liberada';
            case 4:
                return 'Falha na geração';
            default:
                return '';
        }
    }

    exibeSituacaoAssinatura(entity: IFolhaPonto): boolean {
        return this.assinaturaDigitalHabilitada &&
            (
                ((entity.status === 2 && !entity.previa) || entity.status === 3) ||
                entity.situacaoassinatura === 4
            );
    }

	verHistorico(entity: IFolhaPonto): void {
		this.folhaSelecionada = entity;
		this.historicoAberto = true;
		this.historicoFiltro = 'all';
		this.historicoFolha = [];
		this.historicoErro = false;

		if (!entity.apuracaofolha) {
			return;
		}

		this.historicoCarregando = true;

		this.FolhasdePontoService.getHistoricoArquivos(entity.apuracaofolha)
			.then((historico: IFolhaPontoHistoricoAPI[]) => {
				this.historicoFolha = this.transformarHistorico(historico);
			})
			.catch((error: any) => {
				console.error('Erro ao carregar histórico da folha de ponto:', error);
				this.historicoErro = true;
				this.historicoFolha = [];
			})
			.finally(() => {
				this.historicoCarregando = false;
			});
	}

	fecharHistorico(): void {
		this.historicoAberto = false;
		this.historicoFolha = [];
		this.historicoErro = false;
		this.folhaSelecionada = null;
	}

	getHistoricoFiltrado(): IFolhaPontoHistorico[] {
		if (this.historicoFiltro === 'all') {
			return this.historicoFolha;
		}

		const filtroCategoria: Record<HistoricoFiltro, IFolhaPontoHistorico['categoria'] | null> = {
			all: null,
			falhas: 'falha',
			manuais: 'manual',
			sistema: 'sistema'
		};

		const categoria = filtroCategoria[this.historicoFiltro];

		return this.historicoFolha.filter((evento) => evento.categoria === categoria);
	}

	getEventoIndicatorClass(evento: IFolhaPontoHistorico): string {
		switch (evento.categoria) {
			case 'sistema':
				return 'indicator--success';
			case 'manual':
				return 'indicator--info';
			case 'falha':
				return 'indicator--warning';
			default:
				return 'indicator--info';
		}
	}

	getFolhaHistoricoSubtitulo(entity: IFolhaPonto): string {
		const periodo = this.getPeriodoFolha(entity);
		const nome = entity.trabalhador?.nome || '';

		return periodo ? `${nome} - ${periodo}` : nome;
	}

	getFolhaHistoricoSituacaoLabel(entity: IFolhaPonto): string {
		if (this.exibeSituacaoAssinatura(entity)) {
			return this.getSituacaoAssinaturaLabel(entity.situacaoassinatura);
		}

		return this.getSituacaoFolha(entity);
	}

	getFolhaHistoricoSituacaoClass(entity: IFolhaPonto): string {
		if (this.exibeSituacaoAssinatura(entity)) {
			return this.getSituacaoAssinaturaClass(entity.situacaoassinatura);
		}

		return this.getSituacaoFolhaClass(entity.status);
	}

	solicitacaoDeAssinaturaIndividualOuGrupo(entity: IFolhaPonto): void {
		this.busy = true;
		if (this.valorExiste(entity)) {
			let arrayEntities: Array<{ apuracaofolha: string }> = [];
			arrayEntities.push({
				'apuracaofolha': entity.apuracaofolha
			});
			this.FolhasdePontoService.solicitacaoDeAssinatura(arrayEntities);
		} else {
			let arrayEntities: Array<{ apuracaofolha: string }> = [];
			this.entities.forEach((element: IFolhaPonto) => {
				if (
					(element.status === 2 || element.status === 3) &&
					!element.situacaoassinatura
				) {
					arrayEntities.push({
						'apuracaofolha': element.apuracaofolha
					});
				}
			});
			this.FolhasdePontoService.solicitacaoDeAssinatura(arrayEntities);
		}
	}

	desativaSolicitarAssinaturasBtn() {
		return !(this.entities.filter(entity => {
			if (
				(entity.status === 2 || entity.status === 3) &&
				!entity.situacaoassinatura
			) {
				return true;
			}
			return false;
		}).length > 0);
	}

	cancelarAssinatura(entity: IFolhaPonto): void {
		if (!this.podeCancelarAssinatura(entity)) {
			return;
		}

		this.FolhasPontoCancelarAssinaturaModalService.open(entity).result
			.then((comentario: string) => {
				this.busy = true;
				this.FolhasdePontoService.cancelarAssinatura(entity, comentario)
					.catch(() => {/**/});
			})
			.catch(() => {/**/});
	}

	podeCancelarAssinatura(entity: IFolhaPonto): boolean {
		const temPermissao = this.$rootScope.temPermissao('cancelar_assinatura_folha') ||
			this.$rootScope.temPermissao('cancelar_assinatura_documento_trabalhador') ||
			this.$rootScope.temPermissao('solicitar_assinatura_folha');
		const statusValido = (entity.status === 2 && !entity.previa) || entity.status === 3;

		return this.assinaturaDigitalHabilitada &&
			temPermissao &&
			statusValido &&
			entity.situacaoassinatura === 2 &&
			!entity.previa;
	}

	extrairMensagemErro(response: any): string {
		if (!response || !response.data) {
			return '';
		}

		if (typeof response.data === 'string') {
			return response.data;
		}

		return response.data.message ||
			response.data.mensagem ||
			response.data.error ||
			response.data.detail ||
			'';
	}

	transformarHistorico(historicoAPI: IFolhaPontoHistoricoAPI[]): IFolhaPontoHistorico[] {
		if (!Array.isArray(historicoAPI)) {
			return [];
		}

		return historicoAPI.map((item: IFolhaPontoHistoricoAPI, index: number) => {
			const dataHora = moment(item.created_at);
			const dataHoraFormatada = dataHora.isValid()
				? dataHora.format('DD/MM/YYYY [às] HH:mm')
				: '';

			return {
				id: item.arquivotrabalhadorhistorico || `${item.arquivotrabalhador || 'historico'}-${index}`,
				titulo: item.acao || item.tipoacao || '',
				dataHora: dataHoraFormatada,
				descricao: item.mensagem || '',
				responsavel: item.created_by?.nome || '',
				categoria: this.determinarCategoriaHistorico(item)
			};
		});
	}

	determinarCategoriaHistorico(item: IFolhaPontoHistoricoAPI): 'falha' | 'manual' | 'sistema' {
		const acao = (item.acao || '').toLowerCase();
		const mensagem = (item.mensagem || '').toLowerCase();

		if (acao.includes('erro') || acao.includes('falha') || mensagem.includes('erro') || mensagem.includes('falha')) {
			return 'falha';
		}

		if (item.created_by?.nome) {
			return 'manual';
		}

		return 'sistema';
	}

	getPeriodoFolha(entity: IFolhaPonto): string {
		const inicioapuracao = moment(entity.apuracaoponto?.inicioapuracao, 'YYYY-MM-DD');
		const terminoapuracao = moment(entity.apuracaoponto?.terminoapuracao, 'YYYY-MM-DD');

		if (!inicioapuracao.isValid() || !terminoapuracao.isValid()) {
			return '';
		}

		return `${inicioapuracao.format('DD/MM/YYYY')} a ${terminoapuracao.format('DD/MM/YYYY')}`;
	}

	getSituacaoAssinaturaLabel(situacao: number | null): string {
		switch (situacao) {
			case null:
			case 0:
				return 'Enviar para assinatura';
			case 1:
				return 'Aguardando assinatura';
			case 2:
				return 'Assinada';
			case 3:
				return 'Assinatura rejeitada';
			case 4:
				return 'Cancelada';
			default:
				return '';
		}
	}

	getSituacaoAssinaturaClass(situacao: number | null): string {
		switch (situacao) {
			case null:
			case 0:
				return 'label-primary';
			case 1:
				return 'label-warning';
			case 2:
				return 'label-success';
			case 3:
				return 'label-danger';
			case 4:
				return 'label-default';
			default:
				return '';
		}
	}

	getSituacaoFolhaClass(status: number | null): string {
		switch (status) {
			case 0:
				return 'label-warning';
			case 1:
			case 4:
				return 'label-danger';
			case 2:
			case 3:
				return 'label-success';
			default:
				return '';
		}
	}

	podeGerarFolha(tableRowEntity: any): boolean {
		// enum FOLHA
		// const AGUARDANDO_GERACAO = 0;
		// const GERANDO = 1;
		// const GERADOS = 2;
		// const LIBERADA = 3;
		// const ERRO = 4;

		// enum ASSINATURA
		// const DEFAULT = 0;
		// const PENDENTE = 1;
		// const ASSINADA = 2;
		// const REJEITADA = 3;

		const temPermissao = this.$rootScope.temPermissao('gerar_folhas_ponto');
		const isValido = [2, 3, 4].includes(tableRowEntity.status) &&
            tableRowEntity.situacaoassinatura < 2 &&
            (!tableRowEntity.previa || this.isApuracaoAtual(tableRowEntity.apuracaoponto));

		return temPermissao && isValido;
	}
}
